export default "__VITE_ASSET__BrhWgRz7__"